// Module
var code = "<a class=\"text-sm sps-btn sps-btn-outline btn-color-recipe-editor recipeEditorBtn\" data-bind=\"click: Click\"> <i class=\"fa fa-indent\"></i> <!--ko text: Label--><!--/ko--> </a>";
// Exports
export default code;